import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import '../../styles/KpiCard.css';

export const KpiCard = ({ title, value, icon, color, trend, subtitle, isHighlighted }) => {
    const renderTrend = () => {
        if (!trend) return null;

        const { direction = 'neutral', text, label } = trend;

        const iconMap = {
            up: <ArrowUpRight size={16} />,
            down: <ArrowDownRight size={16} />,
            neutral: <Minus size={16} />,
        };

        return (
            <div className={`kpi-trend kpi-trend--${direction}`}>
                {iconMap[direction]}
                <span className="kpi-trend__value">{text}</span>
                <span className="kpi-trend__label">{label || 'vs. semana anterior'}</span>
            </div>
        );
    };

    return (
        <div className={`kpi-card${isHighlighted ? ' kpi-card--highlighted' : ''}`}>
            <div className="kpi-icon" style={{ backgroundColor: color }}>
                {icon}
            </div>
            <div className="kpi-content">
                <p className="kpi-title">{title}</p>
                <h3 className="kpi-value">{value}</h3>
                {subtitle && <p className="kpi-subtitle">{subtitle}</p>}
                {renderTrend()}
            </div>
        </div>
    );
};